import Search from '../search/search.js'
module.exports = {
  Search
}



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/middlewares/search/index.js